<template>
  <div class="html-editor">
    <label class="v-label" style="color: var(--v-textPrimary-base); font-size: 13px;">
      {{ label }}
    </label>
    <QuillEditor
        v-model:content="saisie"
        ref="editor"
        theme="snow"
        style="height: 250px"
        :modules="editorModules"
        :disabled="disabled"
        :content-type="'html'"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from 'vue';
import {QuillEditor} from '@vueup/vue-quill';
import Quill from 'quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

import QuillMention from 'quill-mention';
import type {HtmlParam} from "@/extend/classes/HtmlAttrib.ts";

Quill.register('modules/mention', QuillMention);
const Block = Quill.import('blots/block');
Block.tagName = 'DIV';
Quill.register(Block, true);

export default defineComponent({
  components: {
    QuillEditor,
  },
  props: {
    label: {type: String},
    value: {type: String, required: true},
    disabled: {type: Boolean},
    params: {type: Array as PropType<{ id: number; value: string }[]>},
  },
  computed: {
    saisie: {
      get(): string {
        return this.value.startsWith('<') ? this.value : `<div>${this.value}</div>`;
      },
      set(val: string) {
        const cleanVal = this.cleanMentions(val);
        if (cleanVal !== this.saisie) {
          this.$emit('updated', cleanVal);
        }
      },
    },
    editorModules() {
      return {
        name: 'mention',
        module: QuillMention,
        options: {
          allowedChars: /^[A-Z_.]*$/,
          mentionDenotationChars: ['$'],
          source: this.getMentions,
        },
      };
    },
  },
  methods: {
    cleanMentions(html: string): string {
      const tmpContainer = document.createElement('div');
      tmpContainer.innerHTML = html;
      const mentions = tmpContainer.getElementsByClassName('mention');
      for (let i = 0; i < mentions.length; i++) {
        const mentionElement = mentions[i];
        // Extract and preserve denotation character
        const denotationChar = mentionElement.getAttribute('data-denotation-char') || '';
        const mentionContent = mentionElement.querySelector('span[contenteditable]');
        if (mentionContent) {
          // Remove duplicated denotation character inside contenteditable span
          mentionContent.innerHTML = mentionContent.innerHTML.replace(denotationChar, '');
        }
        // Ensure structure remains intact
        mentionElement.innerHTML = `<span class="ql-mention-denotation-char">${denotationChar}</span>${mentionElement.innerHTML}`;
      }
      return tmpContainer.innerHTML.replace(/\uFEFF/g, '');

    },
    getMentions(searchTerm: string, renderList: any) {
      if (this.params) {
        const values: HtmlParam[] = this.params;
        if (searchTerm.length === 0) {
          renderList(values, searchTerm);
        } else {
          const matches: HtmlParam[] = [];
          for (let i = 0; i < values.length; i++) {
            const value = values[i].value;
            const index = value.toLowerCase().indexOf(searchTerm.toLowerCase());
            if (index >= 0) {
              matches.push(values[i]);
            }
          }
          renderList(matches, searchTerm);
        }
      }
    },
    missing(): boolean {
      return false;
    },
    touch(): boolean {
      return false;
    }
  },
});
</script>

<style src="quill-mention/dist/quill.mention.min.css"/>
<style>
#quill-mention-list {
  padding-left: 0 !important;
  overflow: auto;
  max-height: 200px;
}

#quill-mention-list li {
  white-space: nowrap;
}
</style>